import { useEffect, useState } from "react";
import { http, downloadBlob } from "../../lib/api";
import { Btn, Card } from "../kit/Kit";
import { mxn } from "./common";
import { fDia } from "../../lib/trading";

const Tabla = ({ rows, clases, titulo, testid }) => (
  <Card title={titulo} testid={testid}>
    <div className="overflow-x-auto"><table className="w-full min-w-[640px] text-xs">
      <thead><tr className="text-left text-[#8C867A]"><th className="py-1">Clave</th>{clases.map((c) => <th key={c}>{c}</th>)}<th>Saldo</th><th>% campaña</th></tr></thead>
      <tbody>{rows.map((r) => <tr key={r.clave} className="border-t border-[#F2F0EC]"><td className="py-1 font-medium">{r.clave}</td>
        {clases.map((c) => <td key={c}>{r[c].contratos ? `${r[c].contratos} · ${mxn(r[c].saldo)} · ${r[c].tasa?.toFixed(2)}%` : "—"}</td>)}
        <td>{mxn(r.saldo)}</td><td>{r.pct_campana.toFixed(1)}%</td></tr>)}</tbody>
    </table></div>
  </Card>
);

export const CapReportes = () => {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/captacion/reportes/campana-vs-base").then((r) => setD(r.data)); }, []);
  const excel = () => downloadBlob(`/captacion/reportes/campana-vs-base?formato=xlsx`, `captacion_campana_vs_base_${d.corte}.xlsx`);
  if (!d) return null;
  return (
    <div className="space-y-4" data-testid="cap-reportes">
      <div className="flex flex-wrap items-center gap-3"><p className="text-xs text-[#5C5850]">{d.como} Corte {fDia(d.corte, true)}.</p><Btn kind="secondary" onClick={excel} data-testid="cap-reportes-excel">Excel</Btn></div>
      <Tabla rows={d.por_plazo} clases={d.clases} titulo="Campaña vs base · por plazo" testid="cap-rep-plazo" />
      <Tabla rows={d.por_mes} clases={d.clases} titulo="Por mes de apertura" testid="cap-rep-mes" />
      <Tabla rows={d.por_referenciador} clases={d.clases} titulo="Por referenciador" testid="cap-rep-ref" />
    </div>
  );
};
